/* global jQuery Drupal */
(function ($, Drupal) {
	/**
	 * Element help icon.
	 *
	 * @type {Drupal~behavior}
	 */
	Drupal.behaviors.webformElementHelpIconSpe = {
		attach: function (context) {
			if (!window.tippy) {
				return;
			}

			Drupal.webform.elementHelpIcon.options = {
				interactive: false,
				hideOnClick: false,
			};
		},
	};
})(jQuery, Drupal);
